export enum LogTabType {
  Category,
  Genre,
}
